let internalIsMock: boolean = false;
// const mockReg = /127.0.0.1|localhost|dev.sankuai.com/gi;

/**
 * 是否开启 mock
 * @returns {boolean} 是否开启 mock
 */
export function isMock(): boolean {
  return internalIsMock;
}

/**
 * 设置是否开启 mock
 * @param {boolean} isMock 是否开启 mock
 */
export function setIsMock(mock: boolean): void {
  // if (process.env.NODE_ENV !== 'production') {
  //   internalIsMock = isMock;
  // }
  internalIsMock = mock;
}

/**
 * 参数隧道数据
 * https://km.sankuai.com/page/195064302
 */
export function getParamsTunnelData(): any {
  return {
    "serialCode": "564cdd91-3ff1-4de1-8306-2f79106db12d",
    "oneclickpay_dispatcher": {
        "halfScreenWindow": {"adjustPayList":{"adjustInfo":"优先扣款方式","userPayList":[{"description":"排序第一位的支付方式为优先扣款方式，若扣款失败将按顺序完成扣款","marketPriority":2,"payModeList":[{"bizId":"0","icon":{"disable":"https://p0.meituan.net/payicon/grey_credit_pay.png","enable":"https://p0.meituan.net/payicon/credit_pay.png"},"payMode":7,"payModeText":"美团月付","payTypeUniqueKey":"creditpay"},{"bizId":"738061420","icon":{"disable":"https://img.meituan.net/pay/dis_cmb_g2.png","enable":"https://img.meituan.net/pay/cmb_g4.png"},"payMode":2,"payModeText":"招商银行信用卡 (5895)","payTypeUniqueKey":"quickbank_19_738061420","promoLabel":""},{"bizId":"74180877","icon":{"disable":"https://img.meituan.net/pay/dis_cmb_g2.png","enable":"https://img.meituan.net/pay/cmb_g4.png"},"payMode":2,"payModeText":"招商银行储蓄卡 (1321)","payTypeUniqueKey":"quickbank_38_74180877","promoLabel":""},{"bizId":"0","icon":{"disable":"https://p0.meituan.net/payicon/grey_balance.png","enable":"https://p1.meituan.net/payicon/balance.png"},"payMode":1,"payModeText":"余额","payTypeUniqueKey":"balancepay"}],"payType":2,"secondTitle":"长按右侧图标可拖动调整扣款顺序"}]},"button":{"closeBtn":{"buttonPath":{"payUrl":"cashier/dispatcher"}},"downBtn":{"buttonPath":{"payUrl":"cashier/dispatcher"},"buttonText":"更改付款方式"},"upBtn":{"buttonPath":{"payUrl":"cashier/oneclickpay"}}},"guideRuleName":"","halfScreenType":11,"oneClickPayOpenStatus":0,"payTypeGuideStyleName":"oldStyle","titleModel":{"mainTitle":"美团极速支付","totalFee":"45.10"},"verifyModel":{"noAuthGuideText":"确认开通付款免密码功能","noAuthOpenSwitch":1,"verifyType":1}},
        "extendInfo": {
            "mtPlanId": 1585,
            "sellerId": "11000000003985",
            "oneclickpayModalUrl": "/resource/pay-deduction-part/oneclickpay-modal/0.3.0/index.html"
        },
        "routeStatus": 0,
        "cashierSessionId": "11100300000009915000000",
        "scene": "openOneClickPayAdjustPayList"
    },
    "tradeno": "25061010100001670004461391570930",
    "pay_token": "b3dd392e5680e27ec547cf8096a99c2c",
    "merchant_no": "",
    "pay_success_url": "",
    "redr_url": "",
    "ext_param": "{\"open_oneclickpay\":\"1\",\"serialCode\":\"564cdd91-3ff1-4de1-8306-2f79106db12d\"}",
    "extra_data": "{\"open_oneclickpay\":\"1\",\"serialCode\":\"564cdd91-3ff1-4de1-8306-2f79106db12d\"}",
    "app_name": "group",
    "app_version": "12.29.200",
    "device_platform": "harmony",
    "user_city_id": 0,
    "user_location": "",
    "device_id": "0000000000000993683D7580E4A2F87C48151F5ADAAF8A174776974599960189",
    "device_uuid": "0000000000000993683D7580E4A2F87C48151F5ADAAF8A174776974599960189",
    "app_pay_sdk_version": "13.1.1",
    "device_system_version": "OpenHarmony-5.0.5.165",
    "device_manufacturer": "HUAWEI",
    "device_model": "HUAWEI Mate 60 Pro",
    "user_id": "5168050930",
    "user_token": "AgHLIJLadfBHq-U-EbvJtuKjxG_UElzfYvdKqBOPV3fs7YIxWHxRKDfJqv-CDi-tR8B9JJpMy88mXQAAAADOGQsAVq77t0yUVn-WuGx5CySyi2Vqcu7OKejXAVsYOvhpFhoNudIM04_Huz6BgTqEXWMr",
    "device_install_apps": 3,
    "member_id": "21000219887869",
    "zone_user_id": "5168050930",
    "is_debug": 1,
    "cashier_host": "https://stable.pay.test.sankuai.com",
    "env": "test",
    "stat_time": "1749542151812",
    "network_type": "wifi",
    "half_page_render_data": {
      "initialData": {
        "adjustPayList": {
          "adjustInfo": "优先扣款方式",
          "userPayList": [
            {
              "description": "排序第一位的支付方式为优先扣款方式，若扣款失败将按顺序完成扣款",
              "initAdjust": false,
              "marketPriority": 2,
              "payModeList": [
                {
                  "bizId": "0",
                  "payMode": 7,
                  "payModeText": "美团月付",
                  "payTypeUniqueKey": "creditpay",
                  "preExposureLabel": {
                    "details": [
                      {
                        "discount": 599,
                        "promo_id": "101492",
                        "promo_type": "SUBSIDY",
                        "real_discount": 599
                      }
                    ],
                    "discount": 599
                  }
                },
                {
                  "bizId": "0",
                  "payMode": 1,
                  "payModeText": "余额",
                  "payTypeUniqueKey": "balancepay"
                },
                {
                  "bizId": "5062800383",
                  "payMode": 2,
                  "payModeText": "中国建设银行储蓄卡 (7064)",
                  "payTypeUniqueKey": "quickbank_35_5062800383",
                  "promoLabel": "开通返0.3元"
                }
              ],
              "payType": 2,
              "secondTitle": "长按右侧图标可拖动调整扣款顺序"
            },
          ]
        }
      }
    }
};
}